import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { PlRoutingService } from 'pl-core-services';
import { PLLayout } from '../models';

@UntilDestroy()
@Component({
  templateUrl: './pl-secure-layout.component.html',
  styleUrls: ['./pl-secure-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlSecureLayoutComponent implements OnInit {
  layout: PLLayout;

  constructor(
    private store: Store,
    private plRouting: PlRoutingService,
    private titleService: Title
  ) {}

  ngOnInit() {
    this.plRouting
      .fullData(true)
      .pipe(untilDestroyed(this))
      .subscribe(({ layout, htmlTitle }) => {
        this.layout = layout;
        let workingHtmlTitle = htmlTitle || this.layout?.title;
        workingHtmlTitle = workingHtmlTitle ? `${workingHtmlTitle} - ` : '';
        this.titleService.setTitle(`${workingHtmlTitle}Kanga`);
      });
  }
}
